
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import logo from '../../../../images/shieldgps-logo1.svg';
import { customFetchV2 } from '../../services/custom-fetch-v2.ts';
import Button from '../bits/Button.jsx';
import { SectionTitle } from '../bits/SectionTitle.tsx';
import PasswordTextField from '../bits/PasswordTextField.jsx';
import TextField from '../bits/TextField.jsx';

const AUTH_ENDPOINT = '/users/auth';

class LoginForm extends Component {
  state = {
    email: '',
    password: '',
    rememberMe: true,
    isLoading: false,
    errorMessage: '',
  };

  formFieldChange = input => (e) => {
    const { target } = e;
    const newValue = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ [input]: newValue });
  }

  isSubmitDisabled = () => {
    const { email, password, isLoading } = this.state;
    return email.length === 0 || password.length === 0 || isLoading;
  }

  handleSubmit = (evt) => {
    evt.preventDefault();

    this.setState({
      isLoading: true,
      errorMessage: '',
    });

    customFetchV2(AUTH_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        email: this.state.email,
        method: 'password',
        value: this.state.password,
        rememberMe: this.state.rememberMe,
      }),
      skipAuth: true,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to login.');
        }

        const data = response.data;

        if (!data.result) {
          throw new Error('Incorrect email address or password.');
        }

        window.localStorage.setItem('co.shieldgps.accessToken', data.accessToken);
        window.localStorage.setItem('co.shieldgps.refreshToken', data.refreshToken);

        // Reload entire SPA so initial auth check passes
        window.location.reload();
      })
      .catch((error) => {
        this.setState({
          errorMessage: error.message,
          isLoading: false,
        });
      });
  }

  renderErrorBox = () => {
    if (this.state.errorMessage) {
      return (
        <article className="message is-danger">
          <div className="message-body">
          {this.state.errorMessage}
          </div>
        </article>
      );
    }

    return false;
  }

  renderMessageBox = () => {
    if (!this.state.errorMessage) {
      return null;
    }

    return (
      <div className="login__messageBox">
        <WarningRoundedIcon className="login__messageBox__icon" fontSize="small" />{this.state.errorMessage}
      </div>
    );
  }

  onActivateNewDeviceClick = (e) => {
    e.preventDefault();

    const url = 'https://shieldgps.com/activate';

    if (window.cordova) {
      window.cordova.InAppBrowser.open(url, '_system');
    } else {
      window.open(url, '_system');
    }
  }

  render() {
    return (
      <div className="login">
        <div className="login__header">
          <img src={logo} />
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="login__body__title">
            Sign in to your account
          </div>
          <div>
            <TextField
              autoFocus
              classes={{ root: 'login-field' }}
              id="email"
              type="email"
              label="Email Address"
              value={this.state.email}
              onChange={this.formFieldChange('email')}
              fullWidth
              margin="normal"
              disabled={this.state.isLoading}
            />
          </div>
          <div>
            <PasswordTextField
              classes={{ root: 'login-field' }}
              id="password"
              label="Password"
              value={this.state.password}
              onChange={this.formFieldChange('password')}
              margin="normal"
              disabled={this.state.isLoading}
              />
          </div>
          <div className="login__body__reset">
            <div className="login__body__reset__left">Version {process.env.VERSION}</div>
            <a onClick={this.props.onShowPasswordReset}>Forgot your password?</a>
          </div>
          <div className="login__body__submit">
            <Button
              type="submit"
              disabled={this.isSubmitDisabled()}
              loading={this.state.isLoading}
              color="primary">
                Log in
            </Button>
          </div>
          {this.renderMessageBox()}
          <div className="login__body__alt-options">
            <SectionTitle title="Or" />
            <a onClick={this.onActivateNewDeviceClick}>Activate New Device <i className="fa fa-external-link"></i></a>
          </div>

        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onShowPasswordReset: PropTypes.func.isRequired,
};

export default LoginForm;
